// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"SplitModal_modalContent__JfKo9","footer":"SplitModal_footer__3AJ8a"};